module.exports = __webpack_public_path__ + "static/media/CTLI_14-147w.cc0ec7a0.webp";